import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import NoDataAvailable from './NoDataAvailable';
import { fetchTestCaseCoverageByModules } from '../../../../../modules/dashboard';
import { useQuery } from '@tanstack/react-query';

const GRAPH_TITLE = 'Test Cases Coverage By Module';
const TestCaseCoverageByModule = ({ projectId }) => {
  const { data = [] } = useQuery({
    queryKey: ['testCaseCoverageByModules', projectId],
    queryFn: async () => {
      const response = await fetchTestCaseCoverageByModules(projectId);
      return response?.data || [];
    },
    enabled: !!projectId,
    refetchOnWindowFocus: false,
  });

  return (
    <div className="chart-div">
      {data?.length === 0 ? (
        <NoDataAvailable body={GRAPH_TITLE} />
      ) : (
        <>
          <h5 className="text-dark mb-3">{GRAPH_TITLE}</h5>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              barSize={25}
              data={data?.map((item) => ({
                ...item,
                Automated: item.automated_count ? +item.automated_count : 0,
                'Not Automated': item.not_automated_count
                  ? +item.not_automated_count
                  : 0,
              }))}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="module_name"
                label={{
                  value: 'Modules',
                  position: 'insideBottom',
                  offset: -10,
                }}
                tick={{ fontSize: 12 }}
              />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Legend
                align="center"
                layout="horizontal"
                verticalAlign="bottom"
                wrapperStyle={{ padding: '10px 20px' }}
              />
              <Bar dataKey="Automated" stackId="a" fill='#17a589' />
              <Bar dataKey="Not Automated" stackId="a" fill='#2e86c1' />
            </BarChart>
          </ResponsiveContainer>
        </>
      )}
    </div>
  );
};

export default TestCaseCoverageByModule;
